import { cva, type VariantProps } from "../../lib";

export const textFieldContainerVariants = cva(
  "native:flex gap-spacing-sm flex flex-row items-center overflow-hidden",
  {
    variants: {
      // `md:` is Figma's desktop mode (Size table 4980:6860): one step up in
      // height, padding and radius. A caller that sets its own radius or
      // padding also sets the `md:` one.
      size: {
        sm: "rounded-radius-md md:rounded-radius-lg px-spacing-md md:px-spacing-lg py-spacing-sm md:py-spacing-md h-field-sm md:h-field-sm-dt",
        md: "rounded-radius-lg md:rounded-radius-xl px-spacing-md md:px-spacing-lg py-spacing-md md:py-spacing-lg h-field-md md:h-field-md-dt",
      },
      visualState: {
        default: [
          "border-luce-neutral-border-mediumEmphasis border-1",
          "bg-luce-neutral-background-default",
          "web:hover:border-luce-neutral-border-highEmphasis",
        ].join(" "),
        focused: [
          "border-luce-brand-primaryBorder border-1-5",
          "bg-luce-neutral-background-default",
        ].join(" "),
        error: [
          "border-luce-system-danger-default border-1-5",
          "bg-luce-neutral-background-default",
        ].join(" "),
        disabled: [
          "border-luce-neutral-border-mediumEmphasis border-1",
          "bg-luce-neutral-background-intermediate",
        ].join(" "),
      },
      // Figma's Search (8159:9713): filled and fully round at both widths
      variant: {
        default: "",
        search: "rounded-radius-full md:rounded-radius-full",
      },
    },
    // Search keeps the default field's focus and error borders; at rest and
    // disabled it shows none (the 1px stays, so a hover border shifts nothing)
    compoundVariants: [
      {
        variant: "search",
        visualState: "default",
        class: "bg-luce-neutral-background-intermediate border-transparent",
      },
      {
        variant: "search",
        visualState: ["focused", "error"],
        class: "bg-luce-neutral-background-intermediate",
      },
      { variant: "search", visualState: "disabled", class: "border-transparent" },
    ],
    defaultVariants: {
      size: "sm",
      visualState: "default",
      variant: "default",
    },
  },
);

export type TextFieldContainerVariantsProps = VariantProps<typeof textFieldContainerVariants>;
